module.exports = __webpack_public_path__ + "media/audio2.2372c82f.mp3";